(function(){
  'use strict';
  if(customElements.get('mirrored-backdrop'))return;
  const loadImage=src=>new Promise((resolve,reject)=>{const image=new Image();image.crossOrigin='anonymous';const timer=setTimeout(()=>{image.onload=image.onerror=null;reject(new Error('Image loading timed out'));},30000);image.onload=()=>{clearTimeout(timer);resolve(image);};image.onerror=error=>{clearTimeout(timer);reject(error);};image.src=src;});
  class MirroredBackdrop extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.mirrored=false;this.generation=0;this.editPending=false;
      this.form=document.getElementById(this.getAttribute('form-id'));
      this.product=JSON.parse(this.querySelector('[data-mirror-product]').textContent);
      this.button=this.querySelector('[data-mirror-switch-template]').content.querySelector('[data-mirror-switch]');this.error=this.querySelector('[data-mirror-error]');
      if(!this.form)return;this.form.mirroredBackdrop=this;
      this.querySelectorAll('[data-mirror-orientation]').forEach(input=>input.addEventListener('change',()=>{if(input.checked&&(input.value==='mirrored')!==this.mirrored)this.toggle();}));
      this.querySelector('[data-mirror-contact]').addEventListener('click',()=>this.contact());
      this.form.addEventListener('variant:changed',()=>this.refresh());
      this.form.addEventListener('change',()=>this.invalidate());
      this.form.addEventListener('input',()=>this.invalidate());
      this.form.addEventListener('submit',event=>this.submit(event),true);
      addEventListener('pageshow',()=>this.resetAfterNavigation());
      this.form.addEventListener('formdata',event=>this.serialize(event.formData));
      this.refresh();

    }
    get controller(){return document.querySelector(`custom-size-pricing[form-id="${CSS.escape(this.form.getAttribute('id'))}"]`)?.customSizePricingController;}
    get variant(){return this.product.variants.find(v=>String(v.id)===String(this.form.querySelector('[name=id]')?.value));}
    invalidate(){this.generation++;this.prepared=null;}
    resetAfterNavigation(){this.attempt=(this.attempt||0)+1;this.busy=false;this.replaying=false;this.invalidate();this.restoreSubmitButtons();this.button.removeAttribute('aria-busy');}
    prepareSubmitButtons(){
      this.submitButtonStates=Array.from(this.form.elements).filter(button=>button.type==='submit').map(button=>({button,disabled:button.disabled,busy:button.getAttribute('aria-busy')}));
      for(const {button} of this.submitButtonStates){button.disabled=true;button.setAttribute('aria-busy','true');}
    }
    restoreSubmitButtons(){
      for(const {button,disabled,busy} of this.submitButtonStates||[]){
        button.disabled=disabled;
        if(busy===null)button.removeAttribute('aria-busy');else button.setAttribute('aria-busy',busy);
      }
      this.submitButtonStates=null;
    }
    refresh(){
      const v=this.variant;if(!v)return;this.invalidate();
      const source=String(v.featured_media?.id||this.product.featuredMediaId||'');
      const controller=this.controller;
      if(controller){
        if(this.lastVariant!==String(v.id)||!Number.isInteger(this.sourceIndex)){
          controller.clearCropSelection();controller.cropImageElement=null;controller.cropImageLoadingId++;
          const index=controller.images.findIndex(image=>String(image.id)===source);
          if(index>=0){controller.activeCropImageIndex=index;this.sourceIndex=index;}
        }
        controller.root.toggleAttribute('data-mirrored-backdrop-active',this.mirrored);
        if(this.usesOriginalCustomFlow())this.addModalSwitch(controller);
        if(controller.cropThumbs&&!controller.isCustomerUploadMode())controller.cropThumbs.hidden=false;
      }
      this.lastVariant=String(v.id);
      this.syncMediaOrientation();
      this.syncSwitches();
    }
    syncMediaOrientation(){
      const media=document.querySelector(`product-media[form-id="${CSS.escape(this.form.getAttribute('id'))}"]`);
      const mirrored=this.mirrored&&!this.controller?.isCustomerUploadMode();
      media?.classList.toggle('is-backdrop-mirrored',mirrored);
      const zoomId=media?.querySelector('.product__zoom-button[aria-controls]')?.getAttribute('aria-controls');
      const zoom=zoomId?document.getElementById(zoomId):null;
      if(this.zoomElement&&this.zoomElement!==zoom)this.zoomElement.classList.remove('is-backdrop-mirrored');
      zoom?.classList.toggle('is-backdrop-mirrored',mirrored);
      this.zoomElement=zoom;
    }
    addModalSwitch(controller){
      if(!controller.cropModal||controller.cropModal.querySelector('[data-mirror-modal-switch]'))return;
      const row=document.createElement('div');row.className='mirrored-backdrop__modal-switch';
      const label=this.querySelector('legend').textContent.replace(/:$/, '');
      const button=this.button.cloneNode(true);button.removeAttribute('aria-labelledby');button.removeAttribute('data-mirror-switch');button.setAttribute('aria-label',label);button.dataset.mirrorModalSwitch='';
      button.addEventListener('click',()=>this.toggle());row.append(button);
      controller.cropCanvas?.parentElement?.append(row);
      const canvas=controller.cropCanvas;
      if(canvas){
        canvas.tabIndex=0;
        const instructions={es:'Usa las flechas para mover el recorte; más y menos para cambiar el tamaño.',us:'Use arrow keys to move the crop; plus and minus to resize.',uk:'Use arrow keys to move the crop; plus and minus to resize.',au:'Use arrow keys to move the crop; plus and minus to resize.',de:'Mit den Pfeiltasten den Ausschnitt verschieben; mit Plus und Minus die Größe ändern.',fr:'Utilisez les flèches pour déplacer le cadrage ; plus et moins pour le redimensionner.'};
        canvas.setAttribute('aria-label',instructions[this.dataset.site]);
        canvas.addEventListener('keydown',event=>{
          if(!this.mirrored||!controller.cropRect||!controller.cropImageRect||!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','-','='].includes(event.key))return;
          event.preventDefault();event.stopPropagation();
          const rect=controller.cropRect,step=event.shiftKey?10:2;
          if(['+','-','='].includes(event.key))controller.scaleCropRect(event.key==='-'?0.95:1.05,{x:rect.x+rect.width/2,y:rect.y+rect.height/2});
          else{controller.cropRect=controller.clampCropRect({...rect,x:rect.x+(event.key==='ArrowRight'?step:event.key==='ArrowLeft'?-step:0),y:rect.y+(event.key==='ArrowDown'?step:event.key==='ArrowUp'?-step:0)});controller.drawCropCanvas();}
        });
      }
    }
    syncSwitches(){
      this.querySelectorAll('[data-mirror-orientation]').forEach(input=>{input.checked=(input.value==='mirrored')===this.mirrored;});
      for(const button of [this.button,this.controller?.cropModal?.querySelector('[data-mirror-modal-switch]')].filter(Boolean))button.setAttribute('aria-checked',String(this.mirrored));
      this.querySelector('[data-mirror-notice]').hidden=!this.mirrored;
    }
    toggle(){
      const c=this.controller,wasMirrored=this.mirrored;const saved=c?.confirmedCropData||this.savedCrop;this.mirrored=!this.mirrored;this.invalidate();this.error.textContent='';
      this.toggling=true;
      if(c){
        if(c.cropRect&&c.cropImageRect)c.cropRect.x=c.cropImageRect.x+c.cropImageRect.width-(c.cropRect.x-c.cropImageRect.x)-c.cropRect.width;
        c.clearCropSelection();c.update();c.drawCropCanvas();
        if(c.isCustomerUploadMode())c.renderCustomerUploads();
      }
      if(c&&saved)c.setConfirmedCropData({...saved,mirrored:this.mirrored});
      this.toggling=false;
      c?.root.toggleAttribute('data-mirrored-backdrop-active',this.mirrored);
      this.syncSwitches();
      this.syncMediaOrientation();
      this.animateCropFlip(c,wasMirrored);
    }
    animateCropFlip(controller,wasMirrored){
      if(!controller)return;
      cancelAnimationFrame(this.cropFlipFrame);
      const from=Number.isFinite(controller.mirrorAnimationScale)?controller.mirrorAnimationScale:(wasMirrored?-1:1);
      const to=this.mirrored?-1:1;
      if(!controller.cropModalOpen||!controller.cropImageElement||window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        delete controller.mirrorAnimationScale;controller.drawCropCanvas();return;
      }
      const started=performance.now();
      const draw=now=>{
        const progress=Math.min(1,(now-started)/280);
        controller.mirrorAnimationScale=from+(to-from)*(1-Math.cos(progress*Math.PI))/2;
        controller.drawCropCanvas();
        if(progress<1&&controller.cropModalOpen)this.cropFlipFrame=requestAnimationFrame(draw);
        else{delete controller.mirrorAnimationScale;controller.drawCropCanvas();}
      };
      this.cropFlipFrame=requestAnimationFrame(draw);
    }
    onCropData(data){if(data)this.savedCrop={...data};else if(!this.toggling)this.savedCrop=null;}
    fingerprint(){const c=this.controller;return JSON.stringify([this.variant?.id,this.sourceIndex,c?.isCustomerUploadMode(),c?.widthInput?.value,c?.heightInput?.value,c?.unitSelect?.value,c?.confirmedCropData,c?.uploadItems?.map(i=>[i.originalUrl,i.cropSelection]),this.mirrored]);}
    contact(){
      const area=this.form.closest('section,.shopify-section')||document;
      const candidates=area.querySelectorAll('button,a,summary,.proaccordion');
      const target=[...candidates].find(e=>/ask a question|poser une question|frage stellen|une question|eine frage/i.test(e.textContent||''));
      if(target){if(!target.classList.contains('active')&&target.getAttribute('aria-expanded')!=='true')target.click();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');target.focus();}
      else this.error.textContent=this.dataset.error;
    }
    usesOriginalCustomFlow(){
      const c=this.controller;
      return Boolean(c&&(c.isCustomSizePricingSelected()||c.isCustomerUploadMode()));
    }
    serialize(data){
      for(const [key] of [...data.entries()]){
        const property=key.match(/^properties\[(.*)\]$/)?.[1]||'';
        if(property.startsWith('_flip_')||property.startsWith('_mirror_')||/^(Image Orientation|Original Product Information|Variant ID|Flipped Image(?: [2-8])?)$/.test(property))data.delete(key);
      }
      if(this.usesOriginalCustomFlow()){
        data.set('properties[Image Orientation]',(this.controller.confirmedCropData?.mirrored ?? this.mirrored)?'Mirrored':'Standard');
        return;
      }
      if(!this.mirrored)return;
      if(!this.prepared||this.prepared.generation!==this.generation){data.delete('id');return;}
      data.set('id',this.prepared.quote.variantId);
      for(const [key] of [...data.entries()])if(key.startsWith('properties['))data.delete(key);
      for(const [key,value] of Object.entries(this.prepared.quote.properties))data.set(`properties[${key}]`,value);
      data.set('properties[Image Orientation]','Mirrored');
    }
    async addWithStand(data,standVariantId){
      const body=new FormData();
      for(const [key,value] of data.entries()){
        if(['id','quantity','selling_plan'].includes(key))body.set(`items[0][${key}]`,value);
        else if(key.startsWith('properties['))body.set(`items[0][properties][${key.slice(11,-1)}]`,value);
      }
      body.set('items[1][id]',standVariantId);body.set('items[1][quantity]','1');body.set('sections','mini-cart');
      return fetch(`${window.themeVariables.routes.cartAddUrl}.js`,{method:'POST',body,headers:{'X-Requested-With':'XMLHttpRequest'}});
    }
    async makeProductionFile(original,rect,variantId,mirrored=true){
      const pixels=window.MirroredBackdropCore.pixelRect(rect,original.naturalWidth,original.naturalHeight);
      if(pixels.width*pixels.height>64000000)throw new Error('Image too large');
      const canvas=document.createElement('canvas');canvas.width=pixels.width;canvas.height=pixels.height;
      try{
        const ctx=canvas.getContext('2d');if(!ctx)throw new Error('Image export failed');
        if(mirrored){ctx.translate(pixels.width,0);ctx.scale(-1,1);}
        ctx.drawImage(original,pixels.x,pixels.y,pixels.width,pixels.height,0,0,pixels.width,pixels.height);
        const blob=await new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(new Error('Image export failed')),'image/png'));
        if(blob.size>=20*1024*1024)throw new Error('Image too large');
        return new File([blob],`mirrored-${variantId}-${crypto.randomUUID()}.png`,{type:'image/png'});
      }finally{canvas.width=0;canvas.height=0;}
    }
    async submit(event){
      if(this.replaying)return;
      const controller=this.controller;
      const regenerateOriginal=!this.mirrored&&controller&&(
        controller.isCustomerUploadMode()?controller.uploadItems.length>0:controller.isCustomSizePricingSelected()&&Boolean(controller.confirmedCropData&&!controller.cropFile));
      if(!this.mirrored&&!regenerateOriginal)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(this.busy)return;
      this.attempt=(this.attempt||0)+1;const attempt=this.attempt;
      this.busy=true;this.dataset.state='preparing';const generation=this.generation;const fingerprint=this.fingerprint();const submitter=event.submitter;
      this.error.textContent='';this.button.setAttribute('aria-busy','true');
      this.prepareSubmitButtons();
      try{
        if(!this.form.checkValidity()){this.form.reportValidity();return;}
        // Paint the loader before image decoding, canvas work or quote requests.
        await new Promise(resolve=>requestAnimationFrame(()=>setTimeout(resolve,0)));
        const c=this.controller,v=this.variant,core=window.MirroredBackdropCore;
        if(!v)throw new Error('Product unavailable');
        const isCustom=Boolean(c&&(c.isCustomSizePricingSelected(v)||c.isCustomerUploadMode()));
        if(!isCustom&&!core.materialForVariant(v))throw new Error('Material unavailable');
        if(isCustom&&c.productionImageError)throw new Error('Retry the failed crop before adding this image');
        const uploaded=c?.isCustomerUploadMode()?(c.uploadItems||[]):[];
        const confirmed=c&&!c.isCustomerUploadMode()&&c.confirmedCropData;
        const imageMode=isCustom?(uploaded.length?'customer-upload':confirmed?'product-media':'pending'):'product-media';
        if(uploaded.length>8)throw new Error('Too many uploaded images');
        const files=[],manifest=[];
        let image=null,crop=null;
        if(imageMode==='customer-upload'){
          for(const item of uploaded){
            const original=await loadImage(item.originalUrl);
            const selection=item.cropSelection;
            const rect=selection?{x:selection.x/original.naturalWidth,y:selection.y/original.naturalHeight,width:selection.width/original.naturalWidth,height:selection.height/original.naturalHeight}:{x:0,y:0,width:1,height:1};
            files.push(await this.makeProductionFile(original,rect,v.id,this.mirrored));manifest.push({rect});
          }
        }else if(imageMode==='product-media'){
          image=isCustom?c.getCropImageData(c.activeCropImageIndex):core.imageForVariant(v,this.product.featuredImage);
          if(!image?.src)throw new Error('Source image unavailable');
          crop=isCustom&&confirmed?confirmed:{rect:{x:0,y:0,width:1,height:1}};
          files.push(await this.makeProductionFile(await loadImage(image.src),crop.rect,v.id,this.mirrored));manifest.push({rect:crop.rect});
        }
        if(!this.mirrored||isCustom){
          // Leave the original submit event before replaying a no-image custom form.
          // Browsers suppress a nested requestSubmit while that event is still firing.
          await new Promise(resolve=>setTimeout(resolve,0));
          if(generation!==this.generation||fingerprint!==this.fingerprint())throw new Error('Selection changed');
          if(c.isCustomerUploadMode())files.forEach((file,index)=>{c.uploadItems[index].file=file;});
          else if(files.length){c.cropFile=files[0];c.setCropFileInput(files[0]);}
          this.prepared=null;this.dataset.state='ready';
          this.restoreSubmitButtons();
          this.replaying=true;
          try{this.form.requestSubmit(submitter?.form===this.form?submitter:undefined);}finally{this.replaying=false;}
          return;
        }
        for(let index=0;index<files.length;index++){
          const bytes=await crypto.subtle.digest('SHA-256',await files[index].arrayBuffer());
          manifest[index].hash=[...new Uint8Array(bytes)].map(b=>b.toString(16).padStart(2,'0')).join('');
        }
        const compatibilityMode=this.dataset.site==='es';
        const response=await fetch(`https://shopify-mailer-zyf.onrender.com/api/storefront/mirrored-backdrop/quote?site=${encodeURIComponent(this.dataset.site)}`,{
          method:'POST',headers:{'Content-Type':'application/json'},signal:AbortSignal.timeout(30000),
          body:JSON.stringify({orderFormat:compatibilityMode?undefined:'plain',crop:compatibilityMode?crop:undefined,sourceVariantId:`gid://shopify/ProductVariant/${v.id}`,files:manifest.map(({hash})=>({hash}))})
        });
        if(!response.ok)throw new Error('Quote unavailable');
        const quote=await response.json();
        if(generation!==this.generation||fingerprint!==this.fingerprint()||!this.mirrored)throw new Error('Selection changed');
        const uploadQuote=quote.uploadQuote||quote.properties?._mirror_quote;
        if(!quote.variantId||!uploadQuote)throw new Error('Invalid quote');
        const imageBase64=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result).split(',')[1]);reader.onerror=reject;reader.readAsDataURL(files[0]);});
        const registered=await fetch(`https://shopify-mailer-zyf.onrender.com/api/storefront/mirrored-backdrop/checkout-image?site=${encodeURIComponent(this.dataset.site)}`,{
          method:'POST',headers:{'Content-Type':'application/json'},signal:AbortSignal.timeout(90000),
          body:JSON.stringify({quote:uploadQuote,imageBase64,orderFormat:compatibilityMode?undefined:'plain'})
        });
        if(!registered.ok)throw new Error('Checkout image unavailable');
        const checkoutImage=await registered.json();
        if(!checkoutImage.properties?._mirror_quote)throw new Error('Invalid checkout image');
        if(compatibilityMode){
          checkoutImage.properties={...quote.properties,...checkoutImage.properties};
          checkoutImage.properties['Original Product']=checkoutImage.properties._mirror_source_url;
          checkoutImage.properties['Original SKU']=checkoutImage.properties._mirror_source_sku;
          checkoutImage.properties['Flipped Image']=checkoutImage.properties._mirror_checkout_image;
        }
        const keys=['Material','Original Product','Original SKU','Flipped Image','_mirror_quote'];
        if(keys.some(key=>!checkoutImage.properties[key]))throw new Error('Invalid customization information');
        quote.properties=checkoutImage.properties;
        if(generation!==this.generation||fingerprint!==this.fingerprint()||!this.mirrored)throw new Error('Selection changed');
        this.prepared={generation,quote,files};this.dataset.state='ready';
        this.restoreSubmitButtons();
        this.replaying=true;
        try{this.form.requestSubmit(submitter?.form===this.form?submitter:undefined);}finally{this.replaying=false;}
      }catch(error){if(this.attempt===attempt){this.dataset.state='failed';this.prepared=null;this.error.textContent=this.dataset.error;}}
      finally{if(this.attempt===attempt){this.restoreSubmitButtons();this.busy=false;this.button.removeAttribute('aria-busy');}}
    }
  }
  customElements.define('mirrored-backdrop',MirroredBackdrop);
})();
